import * as React from "react";

function SvgDashboardSettings(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.268 9.814h-1.113c-.26-1.04-.67-2.028-1.222-2.95l.787-.786a.732.732 0 000-1.036L19.958 2.28a.732.732 0 00-1.036 0l-.787.787a10.848 10.848 0 00-2.95-1.222V.732A.732.732 0 0014.454 0h-3.906a.732.732 0 00-.733.732v1.113c-1.04.26-2.028.67-2.95 1.222l-.786-.787a.732.732 0 00-1.036 0L2.28 5.042a.732.732 0 000 1.036l.787.787c-.552.92-.961 1.909-1.222 2.95H.732a.732.732 0 00-.732.732v3.906c0 .405.328.732.732.732h1.113c.26 1.041.67 2.03 1.222 2.95l-.787.787a.732.732 0 000 1.036l2.762 2.762a.732.732 0 001.036 0l.787-.787c.92.552 1.909.961 2.95 1.222v1.113c0 .404.327.732.732.732h3.906a.732.732 0 00.732-.732v-1.113a10.85 10.85 0 002.95-1.222l.787.787a.732.732 0 001.036 0l2.762-2.762a.732.732 0 000-1.036l-.787-.787a10.85 10.85 0 001.222-2.95h1.113a.732.732 0 00.732-.732v-3.906a.732.732 0 00-.732-.733zM12.5 20.068c-4.173 0-7.568-3.395-7.568-7.568S8.327 4.932 12.5 4.932s7.568 3.395 7.568 7.568-3.395 7.568-7.568 7.568z"
        fill="#fff"
        fillOpacity={0.8}
      />
      <path
        d="M12.5 13.232a1.709 1.709 0 100-3.418 1.709 1.709 0 000 3.418zM12.5 14.697a3.178 3.178 0 00-3.17 3.017c.925.564 2.01.89 3.17.89 1.16 0 2.245-.326 3.17-.89a3.178 3.178 0 00-3.17-3.017z"
        fill="#fff"
        fillOpacity={0.8}
      />
      <path
        d="M12.5 6.396A6.11 6.11 0 006.396 12.5c0 1.6.62 3.057 1.63 4.147a4.659 4.659 0 012.26-2.852 3.164 3.164 0 01-.96-2.272A3.177 3.177 0 0112.5 8.35a3.177 3.177 0 013.174 3.173c0 .89-.369 1.695-.96 2.272a4.659 4.659 0 012.26 2.851 6.08 6.08 0 001.63-4.146A6.11 6.11 0 0012.5 6.396z"
        fill="#fff"
        fillOpacity={0.8}
      />
    </svg>
  );
}

export default SvgDashboardSettings;
